import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Modal, Space, Switch, Tooltip, message } from 'antd';
import { PROMOTION } from '../../../../constants/define/translation';
import { ShopType, ShopStatus } from '../../../../types/shop';
import { btnActive } from '../../../../styles';
import { ConfirmAction } from '../../../molecules/confirm/ConfirmAction';
import { patchActiveTileWidgetRepository } from '../../../../repository/mytm/shop/shopRepository';
import { MESSAGE_ERROR } from '../../../../constants/message';
import { postLoginRepository } from '../../../../repository/mytm/auth/loginRepository';
import { UserContext } from '../../../../repository/context/userContext';

interface ActionsColumnProps {
  record: ShopType;
  onRefresh: () => void;
  countRecord: number;
}

export default React.memo((props: ActionsColumnProps) => {
  const { t } = useTranslation(PROMOTION);
  const { record, onRefresh, countRecord } = props;
  const recordActive = record.status === ShopStatus.ACTIVE;
  const userContext = useContext(UserContext);
  const [showHideLoading, setShowHideLoading] = useState(false);
  const onShowHideCard = () => {
    const active = record.status !== ShopStatus.ACTIVE;
    const payload: any = {
      id: record.id,
      active,
    };
    if (active === true && countRecord >= 1) {
      message.error(t('message.error.maxItem'));
      return;
    }

    Modal.confirm({
      title: t('table.popup.title'),
      okText: t('table.popup.okBtn'),
      cancelText: t('table.popup.cancelBtn'),
      icon: <ExclamationCircleOutlined />,
      content: (
        <ConfirmAction
          textConfirmAction={
            record.status === ShopStatus.INACTIVE ? t('table.popup.activate') : t('table.popup.deactivate')
          }
          isConfirmPassword
          textConfirmPassword={t('table.popup.confirmPassword')}
        />
      ),
      onOk() {
        setShowHideLoading(true);
        const onShowHide = () => {
          patchActiveTileWidgetRepository({ ...payload })
            .then(r => {
              onRefresh();
            })
            .catch(e => {
              message.error(e?.errorMessage);
            })
            .finally(() => {
              setShowHideLoading(false);
            });
        };
        const inputPasswordNode = document.getElementById('inputPasswordForConfirm');
        const password = (inputPasswordNode as any).value;
        if (!userContext.user?.email || userContext.user?.email === '') {
          setShowHideLoading(false);
          message.error(MESSAGE_ERROR.M02);
        } else {
          postLoginRepository({
            email: userContext.user?.email,
            password,
          })
            .then(() => {
              onShowHide();
            })
            .catch((e: any) => {
              setShowHideLoading(false);
              message.error(e?.errorMessage);
            });
        }
      },
    });
  };

  return (
    <StyledContainer>
      <Space size="small">
        <Tooltip title={recordActive ? t('table.tooltip.hide') : t('table.tooltip.show')}>
          <Switch
            checked={recordActive}
            onChange={onShowHideCard}
            disabled={showHideLoading}
            loading={showHideLoading}
          />
        </Tooltip>
      </Space>
    </StyledContainer>
  );
});

const StyledContainer = styled.div`
  ${btnActive}
`;
